import { Slide } from '@act/storybook';
import { Typography } from '@mui/material';
import { motion } from 'framer-motion';
import { useTheme } from '@mui/material/styles';

export const IntroSlide = () => {
  const theme = useTheme();

  return (
    <Slide>
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.5, duration: 2.5 }}
      >
        <Typography
          variant="displayMedium"
          fontSize="72px"
          color="primary.contrastText"
          lineHeight="80px"
        >
          <motion.div
            initial={{ color: theme.palette.primary.contrastText }}
            animate={{ color: theme.palette.primaryAccent.main }}
            transition={{ delay: 1.5, duration: 0.75 }}
            style={{ display: 'inline' }}
          >
            2025
          </motion.div>{' '}
          was a huge year
        </Typography>
      </motion.div>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 3.15, duration: 0.75 }}
      >
        <Typography variant="displaySmall" color="primary.contrastText">
          and that's putting it lightly
        </Typography>
      </motion.div>
    </Slide>
  );
};
